module.exports = __webpack_public_path__ + "img/ninjacargo.05d2cc66.png";